/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net Command API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  Feature,
  FeatureActorInput,
  FeatureGroupInput,
  FeaturePercentageInput,
  SchemaValidationErrorResponse,
  StandardError
} from '../../models';

import { axiosClient } from '../../../axiosAdminClient.ts';
import type { ErrorType } from '../../../axiosAdminClient.ts';




/**
 * @summary Features list
 */
export const adminFeatures = (

 signal?: AbortSignal
) => {


      return axiosClient<Feature[]>(
      {url: `/features`, method: 'GET', signal
    },
      );
    }




export const getAdminFeaturesQueryKey = () => {
    return [
    'features'
    ] as const;
    }


export const getAdminFeaturesQueryOptions = <TData = Awaited<ReturnType<typeof adminFeatures>>, TError = ErrorType<StandardError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminFeatures>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getAdminFeaturesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminFeatures>>> = ({ signal }) => adminFeatures(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminFeatures>>, TError, TData>
}

export type AdminFeaturesQueryResult = NonNullable<Awaited<ReturnType<typeof adminFeatures>>>
export type AdminFeaturesQueryError = ErrorType<StandardError>


/**
 * @summary Features list
 */

export function useAdminFeatures<TData = Awaited<ReturnType<typeof adminFeatures>>, TError = ErrorType<StandardError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminFeatures>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminFeaturesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Feature Detail
 */
export const adminFeature = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<Feature>(
      {url: `/features/${id}`, method: 'GET', signal
    },
      );
    }




export const getAdminFeatureQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'features',id
    ] as const;
    }


export const getAdminFeatureQueryOptions = <TData = Awaited<ReturnType<typeof adminFeature>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminFeature>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getAdminFeatureQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminFeature>>> = ({ signal }) => adminFeature(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminFeature>>, TError, TData>
}

export type AdminFeatureQueryResult = NonNullable<Awaited<ReturnType<typeof adminFeature>>>
export type AdminFeatureQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Feature Detail
 */

export function useAdminFeature<TData = Awaited<ReturnType<typeof adminFeature>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminFeature>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminFeatureQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Disable Feature
 */
export const disableAdminFeature = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<Feature>(
      {url: `/features/${id}/disable`, method: 'PUT', signal
    },
      );
    }




export const getDisableAdminFeatureMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableAdminFeature>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof disableAdminFeature>>, TError,{id: string}, TContext> => {

const mutationKey = ['disableAdminFeature'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disableAdminFeature>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  disableAdminFeature(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisableAdminFeatureMutationResult = NonNullable<Awaited<ReturnType<typeof disableAdminFeature>>>

    export type DisableAdminFeatureMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Disable Feature
 */
export const useDisableAdminFeature = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableAdminFeature>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof disableAdminFeature>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDisableAdminFeatureMutationOptions(options), queryClient);
    }
    /**
 * @summary Disable Feature for Actor
 */
export const disableAdminFeatureActor = (
    id: MaybeRefOrGetter<string>,
    featureActorInput?: MaybeRefOrGetter<FeatureActorInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
featureActorInput = toValue(featureActorInput);

      return axiosClient<Feature>(
      {url: `/features/${id}/disable-actor`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: featureActorInput, signal
    },
      );
    }




export const getDisableAdminFeatureActorMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableAdminFeatureActor>>, TError,{id: string;data?: FeatureActorInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof disableAdminFeatureActor>>, TError,{id: string;data?: FeatureActorInput}, TContext> => {

const mutationKey = ['disableAdminFeatureActor'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disableAdminFeatureActor>>, {id: string;data?: FeatureActorInput}> = (props) => {
          const {id,data} = props ?? {};

          return  disableAdminFeatureActor(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisableAdminFeatureActorMutationResult = NonNullable<Awaited<ReturnType<typeof disableAdminFeatureActor>>>
    export type DisableAdminFeatureActorMutationBody = FeatureActorInput | undefined
    export type DisableAdminFeatureActorMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Disable Feature for Actor
 */
export const useDisableAdminFeatureActor = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableAdminFeatureActor>>, TError,{id: string;data?: FeatureActorInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof disableAdminFeatureActor>>,
        TError,
        {id: string;data?: FeatureActorInput},
        TContext
      > => {
      return useMutation(getDisableAdminFeatureActorMutationOptions(options), queryClient);
    }
    /**
 * @summary Disable Feature for Group
 */
export const disableAdminFeatureGroup = (
    id: MaybeRefOrGetter<string>,
    featureGroupInput?: MaybeRefOrGetter<FeatureGroupInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
featureGroupInput = toValue(featureGroupInput);

      return axiosClient<Feature>(
      {url: `/features/${id}/disable-group`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: featureGroupInput, signal
    },
      );
    }




export const getDisableAdminFeatureGroupMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableAdminFeatureGroup>>, TError,{id: string;data?: FeatureGroupInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof disableAdminFeatureGroup>>, TError,{id: string;data?: FeatureGroupInput}, TContext> => {

const mutationKey = ['disableAdminFeatureGroup'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disableAdminFeatureGroup>>, {id: string;data?: FeatureGroupInput}> = (props) => {
          const {id,data} = props ?? {};

          return  disableAdminFeatureGroup(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisableAdminFeatureGroupMutationResult = NonNullable<Awaited<ReturnType<typeof disableAdminFeatureGroup>>>
    export type DisableAdminFeatureGroupMutationBody = FeatureGroupInput | undefined
    export type DisableAdminFeatureGroupMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Disable Feature for Group
 */
export const useDisableAdminFeatureGroup = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableAdminFeatureGroup>>, TError,{id: string;data?: FeatureGroupInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof disableAdminFeatureGroup>>,
        TError,
        {id: string;data?: FeatureGroupInput},
        TContext
      > => {
      return useMutation(getDisableAdminFeatureGroupMutationOptions(options), queryClient);
    }
    /**
 * @summary Enable Feature
 */
export const enableAdminFeature = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<Feature>(
      {url: `/features/${id}/enable`, method: 'PUT', signal
    },
      );
    }




export const getEnableAdminFeatureMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableAdminFeature>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof enableAdminFeature>>, TError,{id: string}, TContext> => {

const mutationKey = ['enableAdminFeature'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof enableAdminFeature>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  enableAdminFeature(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EnableAdminFeatureMutationResult = NonNullable<Awaited<ReturnType<typeof enableAdminFeature>>>

    export type EnableAdminFeatureMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Enable Feature
 */
export const useEnableAdminFeature = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableAdminFeature>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof enableAdminFeature>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getEnableAdminFeatureMutationOptions(options), queryClient);
    }
    /**
 * @summary Enable Feature for Actor
 */
export const enableAdminFeatureActor = (
    id: MaybeRefOrGetter<string>,
    featureActorInput?: MaybeRefOrGetter<FeatureActorInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
featureActorInput = toValue(featureActorInput);

      return axiosClient<Feature>(
      {url: `/features/${id}/enable-actor`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: featureActorInput, signal
    },
      );
    }




export const getEnableAdminFeatureActorMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableAdminFeatureActor>>, TError,{id: string;data?: FeatureActorInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof enableAdminFeatureActor>>, TError,{id: string;data?: FeatureActorInput}, TContext> => {

const mutationKey = ['enableAdminFeatureActor'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof enableAdminFeatureActor>>, {id: string;data?: FeatureActorInput}> = (props) => {
          const {id,data} = props ?? {};

          return  enableAdminFeatureActor(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EnableAdminFeatureActorMutationResult = NonNullable<Awaited<ReturnType<typeof enableAdminFeatureActor>>>
    export type EnableAdminFeatureActorMutationBody = FeatureActorInput | undefined
    export type EnableAdminFeatureActorMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Enable Feature for Actor
 */
export const useEnableAdminFeatureActor = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableAdminFeatureActor>>, TError,{id: string;data?: FeatureActorInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof enableAdminFeatureActor>>,
        TError,
        {id: string;data?: FeatureActorInput},
        TContext
      > => {
      return useMutation(getEnableAdminFeatureActorMutationOptions(options), queryClient);
    }
    /**
 * @summary Enable Feature for Group
 */
export const enableAdminFeatureGroup = (
    id: MaybeRefOrGetter<string>,
    featureGroupInput?: MaybeRefOrGetter<FeatureGroupInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
featureGroupInput = toValue(featureGroupInput);

      return axiosClient<Feature>(
      {url: `/features/${id}/enable-group`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: featureGroupInput, signal
    },
      );
    }




export const getEnableAdminFeatureGroupMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableAdminFeatureGroup>>, TError,{id: string;data?: FeatureGroupInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof enableAdminFeatureGroup>>, TError,{id: string;data?: FeatureGroupInput}, TContext> => {

const mutationKey = ['enableAdminFeatureGroup'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof enableAdminFeatureGroup>>, {id: string;data?: FeatureGroupInput}> = (props) => {
          const {id,data} = props ?? {};

          return  enableAdminFeatureGroup(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EnableAdminFeatureGroupMutationResult = NonNullable<Awaited<ReturnType<typeof enableAdminFeatureGroup>>>
    export type EnableAdminFeatureGroupMutationBody = FeatureGroupInput | undefined
    export type EnableAdminFeatureGroupMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Enable Feature for Group
 */
export const useEnableAdminFeatureGroup = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableAdminFeatureGroup>>, TError,{id: string;data?: FeatureGroupInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof enableAdminFeatureGroup>>,
        TError,
        {id: string;data?: FeatureGroupInput},
        TContext
      > => {
      return useMutation(getEnableAdminFeatureGroupMutationOptions(options), queryClient);
    }
    /**
 * @summary Enable Feature for Percentage of Actors
 */
export const enableAdminFeaturePercentageOfActors = (
    id: MaybeRefOrGetter<string>,
    featurePercentageInput?: MaybeRefOrGetter<FeaturePercentageInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
featurePercentageInput = toValue(featurePercentageInput);

      return axiosClient<Feature>(
      {url: `/features/${id}/enable-percentage-of-actors`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: featurePercentageInput, signal
    },
      );
    }




export const getEnableAdminFeaturePercentageOfActorsMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableAdminFeaturePercentageOfActors>>, TError,{id: string;data?: FeaturePercentageInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof enableAdminFeaturePercentageOfActors>>, TError,{id: string;data?: FeaturePercentageInput}, TContext> => {

const mutationKey = ['enableAdminFeaturePercentageOfActors'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof enableAdminFeaturePercentageOfActors>>, {id: string;data?: FeaturePercentageInput}> = (props) => {
          const {id,data} = props ?? {};

          return  enableAdminFeaturePercentageOfActors(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EnableAdminFeaturePercentageOfActorsMutationResult = NonNullable<Awaited<ReturnType<typeof enableAdminFeaturePercentageOfActors>>>
    export type EnableAdminFeaturePercentageOfActorsMutationBody = FeaturePercentageInput | undefined
    export type EnableAdminFeaturePercentageOfActorsMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Enable Feature for Percentage of Actors
 */
export const useEnableAdminFeaturePercentageOfActors = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableAdminFeaturePercentageOfActors>>, TError,{id: string;data?: FeaturePercentageInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof enableAdminFeaturePercentageOfActors>>,
        TError,
        {id: string;data?: FeaturePercentageInput},
        TContext
      > => {
      return useMutation(getEnableAdminFeaturePercentageOfActorsMutationOptions(options), queryClient);
    }
    /**
 * @summary Enable Feature for Percentage of Time
 */
export const enableAdminFeaturePercentageOfTime = (
    id: MaybeRefOrGetter<string>,
    featurePercentageInput?: MaybeRefOrGetter<FeaturePercentageInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
featurePercentageInput = toValue(featurePercentageInput);

      return axiosClient<Feature>(
      {url: `/features/${id}/enable-percentage-of-time`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: featurePercentageInput, signal
    },
      );
    }




export const getEnableAdminFeaturePercentageOfTimeMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableAdminFeaturePercentageOfTime>>, TError,{id: string;data?: FeaturePercentageInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof enableAdminFeaturePercentageOfTime>>, TError,{id: string;data?: FeaturePercentageInput}, TContext> => {

const mutationKey = ['enableAdminFeaturePercentageOfTime'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof enableAdminFeaturePercentageOfTime>>, {id: string;data?: FeaturePercentageInput}> = (props) => {
          const {id,data} = props ?? {};

          return  enableAdminFeaturePercentageOfTime(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EnableAdminFeaturePercentageOfTimeMutationResult = NonNullable<Awaited<ReturnType<typeof enableAdminFeaturePercentageOfTime>>>
    export type EnableAdminFeaturePercentageOfTimeMutationBody = FeaturePercentageInput | undefined
    export type EnableAdminFeaturePercentageOfTimeMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Enable Feature for Percentage of Time
 */
export const useEnableAdminFeaturePercentageOfTime = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableAdminFeaturePercentageOfTime>>, TError,{id: string;data?: FeaturePercentageInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof enableAdminFeaturePercentageOfTime>>,
        TError,
        {id: string;data?: FeaturePercentageInput},
        TContext
      > => {
      return useMutation(getEnableAdminFeaturePercentageOfTimeMutationOptions(options), queryClient);
    }
    /**
 * @summary Toggle Feature Self-Service
 */
export const toggleAdminFeatureSelfService = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<Feature>(
      {url: `/features/${id}/toggle-self-service`, method: 'PUT', signal
    },
      );
    }




export const getToggleAdminFeatureSelfServiceMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof toggleAdminFeatureSelfService>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof toggleAdminFeatureSelfService>>, TError,{id: string}, TContext> => {

const mutationKey = ['toggleAdminFeatureSelfService'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof toggleAdminFeatureSelfService>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  toggleAdminFeatureSelfService(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ToggleAdminFeatureSelfServiceMutationResult = NonNullable<Awaited<ReturnType<typeof toggleAdminFeatureSelfService>>>

    export type ToggleAdminFeatureSelfServiceMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Toggle Feature Self-Service
 */
export const useToggleAdminFeatureSelfService = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof toggleAdminFeatureSelfService>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof toggleAdminFeatureSelfService>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getToggleAdminFeatureSelfServiceMutationOptions(options), queryClient);
    }
